export default __webpack_public_path__ + "static/media/415_IMG1545.0bf07ba8.jpg";